import Resource from '../../../api/resources/Resource'

class SamplePrintService extends Resource {
    async getLabelReportPdfWithCopiesNumberForPrinting(labId, casId, samples, withUserDefaultNumberOfCopies, workstation) {
        return this.axios.put(`/registry/laboratories/${labId}/cases/${casId}/samples/labels`,
            samples,
            {
                params: {
                    withUserDefaultNumberOfCopies: withUserDefaultNumberOfCopies,
                    workstation: workstation
                }
            }).then(response => response)
    }
}

export default new SamplePrintService()
